import { useRef } from 'react';
import { Input } from '@mantine/core';
import IntlTelInput from '@intl-tel-input/react/with-utils';
import 'intl-tel-input/styles';
import classes from './IntlPhoneInput.module.css';

type Props = {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  error?: string;
  disabled?: boolean;
  size?: 'xs' | 'sm' | 'md';
};

export function IntlPhoneInput({
  label,
  value,
  onChange,
  error,
  disabled,
  size,
}: Props) {
  const className =
    size === 'xs' ? `${classes.wrapper} ${classes.xs}` : classes.wrapper;
  // intl-tel-input reformats whatever value it is given and reports the result
  // back. For a value it cannot resolve to a country it falls back to
  // initialCountry, so an unedited field would emit a rewritten number and mark
  // the form dirty on load. Only propagate changes the user actually made -
  // iti focuses the input before dispatching its country-change event too.
  const touched = useRef(false);
  return (
    <Input.Wrapper
      label={label}
      error={error}
      size={size}
      className={className}
      inputContainer={(c) => <div>{c}</div>}
    >
      <IntlTelInput
        initialCountry="ee"
        separateDialCode
        value={value}
        disabled={disabled}
        inputProps={{
          onFocus: () => {
            touched.current = true;
          },
        }}
        onChangeNumber={(n) => {
          if (touched.current) onChange?.(n);
        }}
      />
    </Input.Wrapper>
  );
}
